import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'cards',
  size: 'full',
  children: {
    list: {
      path: 'list',
      size: 'full',
    },
    cardId: {
      path: ':cardId',
      level: 2,
    },
    new: {
      path: 'new',
    },
  },
} as const satisfies Location
